import { lazy } from "react";

export const SignUp2 = lazy(() => import("./Pages/auth/SignUp"));
export const Login = lazy(() => import("./Pages/auth/Login"));
export const ForgetPassword = lazy(() => import("./Pages/auth/ForgetPassword"));
export const Confirm = lazy(() => import("./Pages/auth/Confirm"));
export const EmailVerified = lazy(() => import("./Pages/auth/EmailVerified"));
export const ContactUs = lazy(() => import("./Pages/ContactUs"));
export const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy"));
export const TermsAndConditions = lazy(() => import("./Pages/TermsAndConditions"));
export const ResourcesPage = lazy(() => import("./Pages/account/Dashboard/Pages/ResourcesPage"));
export const ResourceCategory = lazy(() =>
  import("./Pages/account/Dashboard/Pages/InnerPages/ResourceCategory")
);
export const Resource2 = lazy(() =>
  import("./Pages/account/Dashboard/Pages/InnerPages/Resource")
);
export const MainLayout = lazy(() => import("./Pages/account/Dashboard/LayoutPage"));
export const PublicLayout = lazy(() => import("./Pages/PublicLayout"));
export const OnboardingWizard = lazy(() => import("./Pages/Onboarding/OnboardingWizard"));
export const DashboardPage = lazy(() => import("./Pages/account/Dashboard/Pages/DashboardPage"));
export const UserProfilePage = lazy(() => import("./Pages/account/Dashboard/Pages/UserProfilePage"));
export const ProjectsPage = lazy(() => import("./Pages/account/Dashboard/Pages/ProjectsPage"));
export const OrganizationsPage = lazy(() => import("./Pages/account/Dashboard/Pages/OrganizationsPage"));
export const JobSearchPage = lazy(() => import("./Pages/account/Dashboard/Pages/JobSearchPage"));
export const Settings = lazy(() => import("./Pages/account/Settings/Settings"));
export const MyResources = lazy(() => import("./Pages/account/Dashboard/Pages/InnerPages/MyResources"));
export const ProjectDetails = lazy(() =>
  import("./Pages/account/Dashboard/Pages/InnerPages/ProjectDetails")
);
export const JobDetails = lazy(() => import("./Pages/account/Dashboard/Pages/InnerPages/JobDetails"));
export const JobApplicantList = lazy(() =>
  import("./Pages/account/Dashboard/Pages/InnerPages/JobApplicantList")
);
export const OrganizationDetails = lazy(() =>
  import("./Pages/account/Dashboard/Pages/InnerPages/OrganizationDetails")
);
export const NotFound = lazy(() => import("./Components/NotFound"));
export const AccessDenied = lazy(() => import("./Components/PermissionDenied"));
